import React, { memo } from 'react';
import { useStoresBadges } from '../../hooks/wizardHooks';
import styles from './appBadges.module.scss';

export default memo(function AppBadges() {
    const { appStoreBadgeURL, googlePlayBadgeURL } = useStoresBadges();

    return (
        <div className={styles.container}>
            {/* eslint-disable-next-line global-require */}
            <img alt="AppStore" height={45} src={require(`../../../shared/images/badges/${appStoreBadgeURL}`)} width={150} />
            {/* eslint-disable-next-line global-require */}
            <img alt="GooglePlay" height={45} src={require(`../../../shared/images/badges/${googlePlayBadgeURL}`)} width={150} />
        </div>
    );
});
